import { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";
import { STATS } from "@/lib/data";

const parseNumber = (v) => {
    const match = v.match(/([\d.]+)([A-Za-z+×x]*)/);
    if (!match) return { num: 0, suffix: v };
    return { num: parseFloat(match[1]), suffix: match[2] };
};

const Counter = ({ value }) => {
    const ref = useRef(null);
    const inView = useInView(ref, { once: true, margin: "-40px" });
    const { num, suffix } = parseNumber(value);
    const [current, setCurrent] = useState(0);

    useEffect(() => {
        if (!inView) return;
        let start = 0;
        const duration = 1400;
        const startTime = performance.now();
        const step = (now) => {
            const t = Math.min(1, (now - startTime) / duration);
            const eased = 1 - Math.pow(1 - t, 3);
            setCurrent(start + (num - start) * eased);
            if (t < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
    }, [inView, num]);

    const display = num % 1 === 0 ? Math.round(current) : current.toFixed(1);
    return (
        <span ref={ref} className="big-num text-5xl md:text-6xl">
            {display}
            {suffix}
        </span>
    );
};

const SuccessMetrics = () => (
    <section data-testid="metrics-section" className="sxe-section relative bg-[#08031a] border-y border-white/[0.04]">
        <div className="sxe-container">
            <div className="max-w-3xl">
                <div className="overline"><span className="dot" /> Success Metrics</div>
                <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-medium tracking-tighter leading-[1.05] text-white mt-5">
                    Outcomes that <span className="text-gradient">leadership cares about</span>.
                </h2>
            </div>

            <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 mt-14">
                {STATS.map((s, i) => (
                    <motion.div
                        key={s.label}
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.6, delay: i * 0.05 }}
                        className="sxe-card p-7"
                        data-testid={`metric-${i}`}
                    >
                        <Counter value={s.value} />
                        <div className="mt-3 text-[#B0A3C4] text-sm leading-relaxed">{s.label}</div>
                    </motion.div>
                ))}
            </div>
        </div>
    </section>
);

export default SuccessMetrics;
